import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  sanitizer = inject(DomSanitizer);
  transform(value: string | null | undefined, query: string): SafeHtml {
    const text = value ?? '';
    if (!query) {
      return this.sanitizer.bypassSecurityTrustHtml(text);
    }

    const regex = new RegExp(query, 'gi');
    const replaced = text.replace(
      regex,
      (match) => `<span class="highlight">${match}</span>`,
    );

    return this.sanitizer.bypassSecurityTrustHtml(replaced);
  }
}
